import { Account } from '../../interfaces/Account';
import { AccountResponseDto } from '../../interfaces/Dto/AccountResponseDto';
import transformSecurityQuestion from './transformSecurityQuestion';

export default function transformAccount(dto: AccountResponseDto): Account {
  const account: Account = {
    extranetId: dto?.data?.username,
    username: dto?.data?.username,
    userSecurityQuestions: dto?.data?.userSecurityQuestions.map(transformSecurityQuestion),
    isUsernameReadOnly: dto?.behaviours?.isUsernameReadOnly,
    usernameFormatDescription: dto?.behaviours?.usernameFormatDescription,
    usernameMinLength: dto?.behaviours?.usernameMinLength,
    usernameMaxLength: dto?.behaviours?.usernameMaxLength,
    usernameRegex: new RegExp(dto?.behaviours?.usernameRegex),
    usernameEmailRegex: new RegExp(dto?.behaviours?.usernameEmailRegex),
    behaviours: {
      isUsernameValidationRequired: dto?.behaviours?.isUsernameValidationRequired,
      isSecurityInformationValidationRequired: dto?.behaviours?.isSecurityInformationValidationRequired,
      isSecretQuestionsValidationRequired: dto?.behaviours?.isUsernameValidationRequired,
    },
  };
  return account;
}
